import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'utils/i18n';

interface Props {
  className?: string;
  label?: string;
  added?: boolean;
  enabled?: boolean;
  desktop?: boolean;
  onClick?: () => void;
}

const AddToBookingButton: React.FC<Props> = ({
  className,
  label: labelProp,
  added = false,
  enabled = true,
  desktop = false,
  ...props
}) => {
  const { t } = useTranslation('common');

  const classes = classNames(
    {
      button: true,
      'button--medium': true,
      'button--primary': !added,
      'button--tertiary': !enabled,
      'button--quaternary': added,
    },
    className
  );

  const getLabel = () => {
    if (labelProp !== undefined) return labelProp;
    if (added) return t('shared.booking_added');
    return t(desktop ? 'shared.add_to_booking' : 'shared.book');
  };

  const label = getLabel();

  return (
    <button
      data-testid="addToBookingButton"
      data-cy="addToBookingButton"
      {...props}
      className={classes}
      disabled={added}
    >
      {label}
    </button>
  );
};

export default AddToBookingButton;
